import { overlayStore } from '@/store/overlayStore';
import { mediaQueriesMixin } from './mediaQueries';

export const analyticsMixin = {
    data() {
        return {
            overlayState: overlayStore.state,
        };
    },
    mixins: [mediaQueriesMixin],
    methods: {
        handleCloseQuiz() {
            if (this.closeOnBackgroundClick) {
                this.closeQuestionnaire('Rest');
            }
        },
        trackUsersReturn() {
            const device = this.isMobile() ? 'mobile' : 'desktop';
            if (
                this.$globalConstants.host['return_pop_up_' + device] &&
                this.overlayState.showReturnPopup === null
            ) {
                this.overlayState.showReturnPopup = true;
            }
        },
        trackFeatureImpression(clickOutLink, featureName, partner_id) {
            const params = clickOutLink.replace('/goto/', ''); // replace the path
            const url = `impression/?feature_name=${featureName}&partner_id=${partner_id}&params=${params}`;
            window.axios.defaults.baseURL = '/';
            window.axios.get(url);
            window.axios.defaults.baseURL = window.__api_base_url__;
        },
        clickout(
            category = 'Conversion',
            partner,
            position,
            location,
            event = 'Clickout'
        ) {
            this.trackEvent({
                event,
                category,
                action: 'click',
                label: partner,
                value: position + 1,
                clickLocation: location,
                partner,
            });

            // if (this.$globalConstants.host['facebook_pixel_page_view']) {
            //     window.fbq('track', 'Lead');
            // }

            this.trackUsersReturn();
        },
        readMoreClick(category = 'Conversion', partner, position, location) {
            this.trackEvent({
                event: 'read_more_event',
                category,
                action: 'element click',
                label: 'Read More field',
                value: position + 1,
                clickLocation: location,
                partner_name: partner.partner_name,
                partner,
            });
        },
        quizClick(quizName, step, question, answer, event = 'Quiz Event') {
            this.trackEvent({
                event,
                quizName,
                step,
                question,
                answer,
            });
        },
        closeQuestionnaire(option) {
            this.quizState.loadQuizFirst = false;
            this.quizState.showQuestionnaire = false;

            if (option) {
                this.hasEnded
                    ? this.quizClick(
                          this.$globalConstants.host['quiz_template'],
                          this.step,
                          'Result',
                          `Clicked on ${option} to close the quiz`,
                          'Closed Quiz'
                      )
                    : this.quizClick(
                          this.$globalConstants.host['quiz_template'],
                          this.step,
                          `${this.questionnaire.questions[this.step]['title']}`,
                          `Clicked on ${option} to close the quiz`,
                          'Closed Quiz'
                      );
            }
        },
        bridgePageClick(question, answer) {
            this.trackEvent({
                event: 'Bridge Page Event',
                question,
                answer,
            });
        },
        carouselImage(arrow) {
            this.trackEvent({
                event: 'Images Carousel in Dropdown',
                action: `Carousel moves ${arrow}`,
            });
        },
        popupDeal(action) {
            this.trackEvent({
                event: 'PopUp Deal',
                action: action,
            });
        },
        clickedLang(lang) {
            this.trackEvent({
                event: 'Language Selector',
                question: 'I want to learn',
                answer: lang,
            });
        },
        partnerSignUp(step, message, filledInputs = []) {
            const steps = {
                one: 1,
                two: 2,
                three: 3,
                final: 4,
            };

            // eslint-disable-next-line no-prototype-builtins
            if (steps.hasOwnProperty(step)) {
                step = steps[step];
            }

            this.trackEvent({
                event: 'PartnerSignUp',
                current_step: step,
                message: message,
                user_inputs: filledInputs,
            });
        },
        partnerSignUpError(step, error) {
            this.trackEvent({
                event: 'PartnerSignUp Form Error',
                step: step,
                error_message: error,
            });
        },
        sidebarBillboard(partner) {
            this.trackEvent({
                event: 'sidebar_billboard_impressions',
                label: 'Sidebar Billboard',
                action: 'Impression',
                partner: partner,
            });
        },
        cookieBannerClick(action, label, value) {
            this.trackEvent({
                event: 'Cookie Banner',
                cookie_action: action,
                cookie_label: label,
                cookie_value: value,
            });
        },
        trackEvent(event) {
            if (window.track) {
                window.track.event(event);
            }
        },
    },
};
